import type { LocalDate } from '@konvert/shared';
import { isoWeekday, parseLocalDate } from './civil.js';

const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const WEEKDAYS = [
  'понедельник',
  'вторник',
  'среда',
  'четверг',
  'пятница',
  'суббота',
  'воскресенье',
];

/** "24 сентября 2026" */
export function formatDateRu(date: LocalDate): string {
  const { year, month, day } = parseLocalDate(date);
  return `${day} ${MONTHS_GENITIVE[month - 1]} ${year}`;
}

/** "четверг, 24 сентября 2026" – previews always show the resolved date (SPEC 5.6). */
export function formatDateWithWeekdayRu(date: LocalDate): string {
  return `${WEEKDAYS[isoWeekday(date) - 1]}, ${formatDateRu(date)}`;
}

/** "4 ч 20 мин" */
export function formatMinutesRu(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m} мин`;
  if (m === 0) return `${h} ч`;
  return `${h} ч ${m} мин`;
}

const MONTHS_NOMINATIVE = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
];

/**
 * What a period envelope is called: «с 28 сентября» for a week, «сентябрь» for
 * a month, «2026» for a year. A weekday would say nothing here (2026-09-30).
 */
export function formatPeriodRu(kind: string, periodStart: LocalDate): string {
  const { year, month, day } = parseLocalDate(periodStart);
  if (kind === 'week') return `с ${day} ${MONTHS_GENITIVE[month - 1]}`;
  if (kind === 'month') return `${MONTHS_NOMINATIVE[month - 1]}`;
  if (kind === 'year') return String(year);
  return formatDateRu(periodStart);
}
